import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7639f63d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Magic Links", -1 /* HOISTED */))
const _hoisted_2 = { class: "table table-bordered" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "User:"),
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th", null, "Expiry:"),
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */))
const _hoisted_7 = ["value"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Token", -1 /* HOISTED */))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Expiry Date", -1 /* HOISTED */))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Date Used", -1 /* HOISTED */))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "IP Address", -1 /* HOISTED */))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Copy To Clipboard", -1 /* HOISTED */))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Cancel", -1 /* HOISTED */))
const _hoisted_17 = { key: 0 }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { key: 3 }
const _hoisted_22 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("table", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, [
            _createVNode(_component_VueMultiselect, {
              modelValue: _ctx.userChoice,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userChoice) = $event)),
              class: "magic-link-user-search",
              placeholder: "Enter 5 characters to search",
              "internal-search": false,
              options: _ctx.userSearchResults,
              label: "DisplayName",
              "track-by": "UserID",
              onSearchChange: _ctx.magicLinkUserSearch
            }, null, 8 /* PROPS */, ["modelValue", "options", "onSearchChange"])
          ]),
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("td", null, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.expiryChoice) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectableExpiryDates, (d) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: d[1],
                  value: d[1]
                }, _toDisplayString(d[0]), 9 /* TEXT, PROPS */, _hoisted_7))
              }), 128 /* KEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */), [
              [_vModelSelect, _ctx.expiryChoice]
            ])
          ]),
          _hoisted_8,
          _hoisted_9,
          _createElementVNode("td", null, [
            _createElementVNode("button", {
              class: "thought-btn",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.generateMagicLink()), ["prevent"]))
            }, " Create Magic Link ")
          ]),
          _hoisted_10
        ])
      ]),
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", {
            class: _normalizeClass([{'active-filter-header': _ctx.sortColumn === 'email', 'reverse-filter-header': !_ctx.sortDirection}, "filter-header"]),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sortMagicLinks('email')))
          }, " Email ", 2 /* CLASS */),
          _createElementVNode("th", {
            class: _normalizeClass([{'active-filter-header': _ctx.sortColumn === 'status', 'reverse-filter-header': !_ctx.sortDirection}, "filter-header"]),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sortMagicLinks('status')))
          }, " Status ", 2 /* CLASS */),
          _hoisted_11,
          _createElementVNode("th", {
            class: _normalizeClass([{'active-filter-header': _ctx.sortColumn === 'created', 'reverse-filter-header': !_ctx.sortDirection}, "filter-header"]),
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sortMagicLinks('created')))
          }, " Date Created ", 2 /* CLASS */),
          _hoisted_12,
          _hoisted_13,
          _hoisted_14,
          _hoisted_15,
          _hoisted_16
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedMagicLinks, (magicLink) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: magicLink.Token
          }, [
            _createElementVNode("td", null, _toDisplayString(magicLink.Email), 1 /* TEXT */),
            _createElementVNode("td", null, _toDisplayString(_ctx.getStatusDisplay(magicLink)), 1 /* TEXT */),
            _createElementVNode("td", null, _toDisplayString(magicLink.Token), 1 /* TEXT */),
            _createElementVNode("td", null, _toDisplayString(magicLink.DateCreated.toLocaleString('en-GB')), 1 /* TEXT */),
            _createElementVNode("td", null, _toDisplayString(magicLink.ExpiryDate.toLocaleString('en-GB')), 1 /* TEXT */),
            _createElementVNode("td", null, _toDisplayString(magicLink.DateUsed?.toLocaleString('en-GB')), 1 /* TEXT */),
            _createElementVNode("td", null, _toDisplayString(magicLink.UserIpAddress), 1 /* TEXT */),
            (_ctx.getStatusDisplay(magicLink) === 'unused')
              ? (_openBlock(), _createElementBlock("td", _hoisted_17, [
                  _createElementVNode("button", {
                    class: "thought-btn",
                    onClick: _withModifiers(($event: any) => (_ctx.copyMagicLink(magicLink.Token, magicLink.Email)), ["prevent"])
                  }, " Copy ", 8 /* PROPS */, _hoisted_18)
                ]))
              : (_openBlock(), _createElementBlock("td", _hoisted_19)),
            (_ctx.getStatusDisplay(magicLink) === 'unused')
              ? (_openBlock(), _createElementBlock("td", {
                  key: 2,
                  class: "cancel-magic-link-button",
                  onClick: ($event: any) => (_ctx.cancelMagicLink(magicLink.Token))
                }, " ✕ ", 8 /* PROPS */, _hoisted_20))
              : (_openBlock(), _createElementBlock("td", _hoisted_21))
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      (!_ctx.historicalDataLoaded)
        ? (_openBlock(), _createElementBlock("tbody", _hoisted_22, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", {
                class: "show-historical-links",
                colspan: "99",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getHistoricalMagicLinks()))
              }, " Click to load historical Data ")
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}